import axios from "./userInstance";

interface DeleteUserRolesPayload {
  email: string;
  roles: string[];
}

export default async (payload: DeleteUserRolesPayload) => {
  const response = await axios.delete(`/users/roles/v2`, { data: payload });
  return response.data || true
}
